const AUTH = {
  LOGIN_SUCCESS: 'LOGIN_SUCCESS',
  GET_AUTHORIZED_USER_SUCCESS: 'GET_AUTHORIZED_USER_SUCCESS',
  GET_AUTHORIZED_USER_FAILURE: 'GET_AUTHORIZED_USER_FAILURE',
  LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
}

export default AUTH
